exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-list {\n  min-height: 400px;\n}\n.document-name p {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  color: #54667a;\n}\n.document-create-date {\n  line-height: 14px;\n  font-size: 12px;\n  color: #9e9e9e;\n}\n.document-type-icon {\n  font-size: 24px;\n  color: #6faaf3;\n}\n.date-label-container {\n  line-height: 1;\n  padding-top: 4px;\n}\n.document-actions-container {\n  padding-bottom: 4px;\n}\n.document-name-hover p:hover {\n  text-decoration: underline;\n  -webkit-text-decoration-color: #0f8edd;\n          text-decoration-color: #0f8edd;\n}\n\n", ""]);

// exports
